export default function IsAssigned(object) {
  if (object !== null && object !== undefined && object !== "undefined") {
    return true;
  } else {
    return false;
  }
}
